<template>
  <i
    class="tm-overlay-border"
    :class="[
      {
        f: isFirst,
        l: isLast,
      },
      $props.borderMode,
    ]"
    :style="{
      borderLeftWidth: horizontalBorderWidth,
      borderRightWidth: horizontalBorderWidth,
    }"
  />
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'tmOverlayBorder',

  props: {
    isFirst: { type: Boolean, required: true },
    isLast: { type: Boolean, required: true },
    borderMode: { type: String, required: true },
    rectangle: { type: Object, required: true },
  },

  computed: {
    ...mapState('timemachine', {
      pxVisualSpanBorder: (state) => state.cssVariables.pxVisualSpanBorder,
    }),

    horizontalBorderWidth() {
      let rv = `${this.pxVisualSpanBorder}px`;
      if (this.$props.rectangle) {
        if (this.$props.rectangle.width <= 2 * this.pxVisualSpanBorder) {
          rv = `${-0.5 + this.$props.rectangle.width / 2}px`;
        }
      }
      return rv;
    },
  },
};
</script>

<style lang="scss">
.tm-overlay-span > .tm-overlay-border {
  --border-style: solid;
  --border-colour: red;
  --border-shadow-colour: rgba(0, 0, 0, 0.15);

  position: absolute;
  top: 0;
  pointer-events: none;
  box-shadow: 0 1px 4px var(--border-shadow-colour);
  z-index: var(--tm-zOverlayBorder);

  &.p {
    --border-colour: rgba(255, 255, 255, 0.6);
  }

  &.d {
    --border-colour: #fff;
  }

  &.s {
    --border-colour: #{$color-secondary};
    --border-shadow-colour: rgba(0, 0, 0, 0.4);
  }

  &.r {
    --border-colour: var(--tm-replaceColour);
    --border-style: dashed;
  }

  &.f {
    border-left: var(--tm-pxVisualSpanBorder) var(--border-style)
      var(--border-colour);
  }

  &.l {
    border-right: var(--tm-pxVisualSpanBorder) var(--border-style)
      var(--border-colour);
  }

  border-top: var(--tm-pxVisualSpanBorder) var(--border-style)
    var(--border-colour);
  border-bottom: var(--tm-pxVisualSpanBorder) var(--border-style)
    var(--border-colour);
}
</style>
